export const ENGLISH = 'English'
export const ENGLISH_TOGGLE_KEY = 'toggle-english'
export const ENGLISH_DATA_TESTID = 'lang-toggle-english'
export const SPANISH = 'Spanish'
export const SPANISH_TOGGLE_KEY = 'toggle-spanish'
export const SPANISH_DATA_TESTID = 'lang-toggle-spanish'
